// extracted by mini-css-extract-plugin
export default {"container":"Lead_container__beMD8"};